import { useEffect, useState } from 'react'
import CoiffeurService from 'service/CoiffeurService'

// locals
import { IGetCoiffeurTimeTableList } from 'types/CoiffeurType'
import DateUtil from 'utils/DateUtil'
import { groupBy } from 'utils/Miscellaneous'

export default function useGetCoiffeurReservationTable(
  selectedCoiffeurId: number,
  subServiceId: number,
  dateFromList: Date,
  locationId: number,
  isCalendar: boolean = false
) {
  const [timeTable, setTimeTable] = useState<IGetCoiffeurTimeTableList[] | []>([])
  const selectedDate = DateUtil.getWeekStartEndFromDate(dateFromList)
  const [tableWeek, setTableWeek] = useState(selectedDate)
  const [availableDates, setAvailableDates] = useState({ start: 0, end: 0 })
  const [selectedReservation, setSelectedReservation] = useState<IGetCoiffeurTimeTableList>()
  const [sidebarVisible, setSidebarVisible] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    CoiffeurService.getCoiffeurServiceByLocalId(locationId).then((res) =>
      setAvailableDates({
        start: res.data.reservationStartDay,
        end: res.data.reservationEndDay,
      })
    )
  }, [locationId])

  /* GET Coiffeur Reservation TimeTable */
  useEffect(() => {
    setLoading(true)
    CoiffeurService.getCoiffeurReservationTableList({
      coiffeurId: selectedCoiffeurId,
      subserviceId: subServiceId,
      startDate: DateUtil.formatDateToString(tableWeek.start),
      endDate: DateUtil.formatDateToString(tableWeek.end),
    })
      .then((res) => setTimeTable(res.data))
      .finally(() => setLoading(false))

    /* Reset selected appointment time */
    if (!isCalendar) setSelectedReservation(undefined)
  }, [selectedCoiffeurId, subServiceId, tableWeek.start, tableWeek.end, isCalendar])

  useEffect(() => {
    const selectedDate = DateUtil.getWeekStartEndFromDate(dateFromList)
    setTableWeek(selectedDate)
  }, [dateFromList, selectedCoiffeurId])

  const dailyReservations: [] | Record<string, IGetCoiffeurTimeTableList[]> = !!timeTable.length
    ? groupBy(timeTable, (v) => DateUtil.formatStringToDate(v.reservationStartHour))
    : []

  return {
    availableDates,
    tableWeek,
    setTableWeek,
    selectedReservation,
    setSelectedReservation,
    sidebarVisible,
    setSidebarVisible,
    dailyReservations,
    loading,
  }
}
